export default __webpack_public_path__ + "static/media/asistencia.255e6a44.jpg";